module.exports = __webpack_public_path__ + "static/img/invited-first.91b060d9.png";